export const environment = {
  production: false,
apiUrl: 'http://localhost:8080/api',
  googleClientId: 'YOUR_GOOGLE_OAUTH_CLIENT_ID.apps.googleusercontent.com',
};
